import { DateService, DeviceIdService } from '@pulse/browser-shared';
import { PulseStorage } from '@pulse/common';
import { ResponseTrackerService } from './response-tracker.service';

interface SegmentsCache {
    segments: string[];
    ts: number;
}

export class SegmentsResolverService {
    private storageKey: string;

    constructor(
        private responseTracker: ResponseTrackerService,
        private storage: PulseStorage,
        private deviceId: DeviceIdService,
        private date: DateService,
    ) {
        this.storageKey = `segments-${this.deviceId.getDeviceId().substring(0, 5)}`;

        this.responseTracker.responses().subscribe((res) => {
            if (Array.isArray(res.segments)) {
                this.persist(res.segments);
            }
        });
    }

    async getSegments() {
        const cache = this.read();

        return cache?.segments || [];
    }

    private persist(segments: string[]) {
        this.storage.setJSON<SegmentsCache>(this.storageKey, { segments, ts: this.date.now() });
    }

    private read() {
        return this.storage.getJSON<SegmentsCache>(this.storageKey);
    }
}
